export const TYPE_NULL = 'null';
export const TYPE_SYMBOL = 'symbol';
export const TYPE_BOOL = 'bool';
export const TYPE_INT = 'int';
export const TYPE_FLOAT = 'float';
export const TYPE_DECIMAL = 'decimal';
export const TYPE_STRING = 'string';
export const TYPE_TEXT = 'text';
export const TYPE_UTC_DATETIME = 'utc_datetime';
export const TYPE_ZONED_DATETIME = 'zoned_datetime';
export const TYPE_LOCAL_DATETIME = 'local_datetime';
export const TYPE_LOCAL_DATE = 'local_date';
export const TYPE_LOCAL_TIME = 'local_time';
export const TYPE_DURATION = 'duration';

export const OP_AND = 'and';
export const OP_OR = 'or';
export const OP_NOT = 'not';
export const OP_EQ = 'eq';
export const OP_NE = 'ne';
export const OP_GT = 'gt';
export const OP_GE = 'ge';
export const OP_LT = 'lt';
export const OP_LE = 'le';

export const ALL_OPS = [
    OP_AND,
    OP_OR,
    OP_NOT,
    OP_EQ,
    OP_NE,
    OP_GT,
    OP_GE,
    OP_LT,
    OP_LE,
];

export const ALL_UN_OPS = [
    OP_NOT,
];

export const ALL_BIN_OPS = [
    OP_AND,
    OP_OR,
    OP_EQ,
    OP_NE,
    OP_GT,
    OP_GE,
    OP_LT,
    OP_LE,
];

export const FUNC_BOOL_FORMAT = 'bool_format';
export const FUNC_STR_CONTAINS = 'str_contains';
export const FUNC_STR_STARTS_WITH = 'str_starts_with';
export const FUNC_STR_ENDS_WITH = 'str_ends_with';
export const FUNC_STR_LENGTH = 'str_length';
export const FUNC_STR_TRIM = 'str_trim';
export const FUNC_STR_PAD_START = 'str_pad_start';
export const FUNC_STR_PAD_END = 'str_pad_end';
export const FUNC_STR_PART = 'str_part';
export const FUNC_STR_LEFT = 'str_left';
export const FUNC_STR_RIGHT = 'str_right';
export const FUNC_STR_TO_UPPER = 'str_to_upper';
export const FUNC_STR_TO_LOWER = 'str_to_lower';
export const FUNC_STR_CONCAT = 'str_concat';
export const FUNC_STR_INDEX_OF = 'str_index_of';
export const FUNC_STR_LAST_INDEX_OF = 'str_last_index_of';
export const FUNC_STR_REPLACE = 'str_replace';
export const FUNC_STR_PARSE_BOOL = 'str_parse_bool';
export const FUNC_STR_PARSE_INT = 'str_parse_int';
export const FUNC_STR_PARSE_FLOAT = 'str_parse_float';
export const FUNC_STR_PARSE_DECIMAL = 'str_parse_decimal';
export const FUNC_STR_PARSE_UTC = 'str_parse_utc';
export const FUNC_STR_PARSE_ZONED = 'str_parse_zoned';
export const FUNC_STR_PARSE_LOCAL = 'str_parse_local';
export const FUNC_STR_PARSE_LOCAL_DATE = 'str_parse_local_date';
export const FUNC_STR_PARSE_LOCAL_TIME = 'str_parse_local_time';
export const FUNC_NUM_ROUND = 'num_round';
export const FUNC_NUM_FLOOR = 'num_floor';
export const FUNC_NUM_CEILING = 'num_ceiling';
export const FUNC_NUM_TRUNCATE = 'num_truncate';
export const FUNC_NUM_ABS = 'num_abs';
export const FUNC_NUM_SIGN = 'num_sign';
export const FUNC_NUM_MIN = 'num_min';
export const FUNC_NUM_MAX = 'num_max';
export const FUNC_NUM_CLAMP = 'num_clamp';
export const FUNC_NUM_FORMAT = 'num_format';
export const FUNC_NUM_TO_INT = 'num_to_int';
export const FUNC_NUM_TO_FLOAT = 'num_to_float';
export const FUNC_NUM_TO_DECIMAL = 'num_to_decimal';
export const FUNC_DATE_GET_YEAR = 'date_get_year';
export const FUNC_DATE_GET_MONTH = 'date_get_month';
export const FUNC_DATE_GET_WEEK = 'date_get_week';
export const FUNC_DATE_GET_WEEKDAY = 'date_get_weekday';
export const FUNC_DATE_GET_DAY = 'date_get_day';
export const FUNC_DATE_GET_HOURS = 'date_get_hours';
export const FUNC_DATE_GET_MINUTES = 'date_get_minutes';
export const FUNC_DATE_GET_SECONDS = 'date_get_seconds';
export const FUNC_DATE_NOW_UTC = 'date_now_utc';
export const FUNC_DATE_NOW_LOCAL = 'date_now_local';
export const FUNC_DATE_FORMAT = 'date_format';
export const FUNC_DATE_GET_ZONE = 'date_get_zone';
export const FUNC_DATE_SET_ZONE = 'date_set_zone';
export const FUNC_DATE_TO_UTC = 'date_to_utc';
export const FUNC_DATE_TO_ZONED = 'date_to_zoned';
export const FUNC_DATE_TO_LOCAL = 'date_to_local';
export const FUNC_DATE_TO_LOCAL_DATE = 'date_to_local_date';
export const FUNC_DATE_TO_LOCAL_TIME = 'date_to_local_time';
export const FUNC_DATE_ADD = 'date_add';
export const FUNC_DATE_DIFF = 'date_diff';
export const FUNC_DURATION_FROM = 'duration_from';
export const FUNC_DURATION_FROM_MS = 'duration_from_ms';
export const FUNC_DURATION_FROM_SECONDS = 'duration_from_seconds';
export const FUNC_DURATION_TO_MS = 'duration_to_ms';
export const FUNC_DURATION_TO_SECONDS = 'duration_to_seconds';
export const FUNC_VAL_CHOOSE = 'val_choose';
export const FUNC_VAL_DEFAULT = 'val_default';
export const FUNC_VAL_COALESCE = 'val_coalesce';
export const FUNC_VAL_IS_EMPTY = 'val_is_empty';
export const FUNC_VAL_IS_BETWEEN = 'val_is_between';
export const FUNC_SYMBOL_TO_STRING = 'symbol_to_string';
export const FUNC_STRING_TO_SYMBOL = 'string_to_symbol';
export const FUNC_REF_EQUALS = 'ref_equals';
export const FUNC_REF_IS_NULL = 'ref_is_null';
export const FUNC_KEY_EQUALS = 'key_equals';
export const FUNC_KEY_TO_STRING = 'key_to_string';
export const FUNC_NEW_UID = 'new_uid';
export const FUNC_GET_CURRENT_USER = 'get_current_user';
export const FUNC_LIST_CONTAINS = 'list_contains';
export const FUNC_LIST_LENGTH = 'list_length';
export const FUNC_LIST_GET = 'list_get';
export const FUNC_LIST_JOIN = 'list_join';
export const FUNC_LIST_SUM = 'list_sum';
export const FUNC_LIST_MIN = 'list_min';
export const FUNC_LIST_MAX = 'list_max';

export const ALL_FUNCS = [
    FUNC_BOOL_FORMAT,
    FUNC_STR_CONTAINS,
    FUNC_STR_STARTS_WITH,
    FUNC_STR_ENDS_WITH,
    FUNC_STR_LENGTH,
    FUNC_STR_TRIM,
    FUNC_STR_PAD_START,
    FUNC_STR_PAD_END,
    FUNC_STR_PART,
    FUNC_STR_LEFT,
    FUNC_STR_RIGHT,
    FUNC_STR_TO_UPPER,
    FUNC_STR_TO_LOWER,
    FUNC_STR_CONCAT,
    FUNC_STR_INDEX_OF,
    FUNC_STR_LAST_INDEX_OF,
    FUNC_STR_REPLACE,
    FUNC_STR_PARSE_BOOL,
    FUNC_STR_PARSE_INT,
    FUNC_STR_PARSE_FLOAT,
    FUNC_STR_PARSE_DECIMAL,
    FUNC_STR_PARSE_UTC,
    FUNC_STR_PARSE_ZONED,
    FUNC_STR_PARSE_LOCAL,
    FUNC_STR_PARSE_LOCAL_DATE,
    FUNC_STR_PARSE_LOCAL_TIME,
    FUNC_NUM_ROUND,
    FUNC_NUM_FLOOR,
    FUNC_NUM_CEILING,
    FUNC_NUM_TRUNCATE,
    FUNC_NUM_ABS,
    FUNC_NUM_SIGN,
    FUNC_NUM_MIN,
    FUNC_NUM_MAX,
    FUNC_NUM_CLAMP,
    FUNC_NUM_FORMAT,
    FUNC_NUM_TO_INT,
    FUNC_NUM_TO_FLOAT,
    FUNC_NUM_TO_DECIMAL,
    FUNC_DATE_GET_YEAR,
    FUNC_DATE_GET_MONTH,
    FUNC_DATE_GET_WEEK,
    FUNC_DATE_GET_WEEKDAY,
    FUNC_DATE_GET_DAY,
    FUNC_DATE_GET_HOURS,
    FUNC_DATE_GET_MINUTES,
    FUNC_DATE_GET_SECONDS,
    FUNC_DATE_NOW_UTC,
    FUNC_DATE_NOW_LOCAL,
    FUNC_DATE_FORMAT,
    FUNC_DATE_GET_ZONE,
    FUNC_DATE_SET_ZONE,
    FUNC_DATE_TO_UTC,
    FUNC_DATE_TO_ZONED,
    FUNC_DATE_TO_LOCAL,
    FUNC_DATE_TO_LOCAL_DATE,
    FUNC_DATE_TO_LOCAL_TIME,
    FUNC_DATE_ADD,
    FUNC_DATE_DIFF,
    FUNC_DURATION_FROM,
    FUNC_DURATION_FROM_MS,
    FUNC_DURATION_FROM_SECONDS,
    FUNC_DURATION_TO_MS,
    FUNC_DURATION_TO_SECONDS,
    FUNC_VAL_CHOOSE,
    FUNC_VAL_IS_EMPTY,
    FUNC_VAL_IS_BETWEEN,
    FUNC_SYMBOL_TO_STRING,
    FUNC_STRING_TO_SYMBOL,
    FUNC_KEY_EQUALS,
    FUNC_KEY_TO_STRING,
    FUNC_NEW_UID,
    FUNC_GET_CURRENT_USER,
    FUNC_LIST_CONTAINS,
    FUNC_LIST_LENGTH,
    FUNC_LIST_GET,
    FUNC_LIST_JOIN,
    FUNC_LIST_SUM,
    FUNC_LIST_MIN,
    FUNC_LIST_MAX,
];

export function isUnaryOperator(name) {
    return ALL_UN_OPS.includes(name);
}

export function isBinaryOperator(name) {
    return ALL_BIN_OPS.includes(name);
}

export function isFunctionName(name) {
    return ALL_FUNCS.includes(name);
}
